import { baseApi } from '@store/baseApi';

export interface SalesScoreboardResponse {
  period_start: string;
  period_end: string;

  // Metric 1: Net MRR growth
  mrr_current_cents: number;
  mrr_period_start_cents: number;
  net_mrr_growth_cents: number;

  // Metric 2: Gross churn (logo-based, trailing 30-day)
  churn_base_logos: number;
  churned_logos: number;
  gross_churn_pct: number | null;

  // Metric 3: JotBill Go-live count
  jotbill_golive_count: number;

  // Metric 4: % of goal
  jotbill_golive_goal: number;
  jotbill_golive_pct: number | null;

  // Cache metadata
  computed_at: string | null;

  // Notion access status
  notion_accessible: boolean;
  notion_error: string | null;
}

export interface SalesScoreboardQueryParams {
  periodStart?: string;
  periodEnd?: string;
}

const toApiParams = (params: SalesScoreboardQueryParams) => ({
  period_start: params.periodStart,
  period_end: params.periodEnd,
});

const salesScoreboardApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getSalesScoreboard: builder.query<SalesScoreboardResponse, SalesScoreboardQueryParams>({
      query: params => ({
        url: '/v2/admin/billing/dashboard/sales-scoreboard',
        params: toApiParams(params),
      }),
    }),
  }),
});

export const { useGetSalesScoreboardQuery } = salesScoreboardApi;
